import React, { useRef } from "react";
import YouTube from "react-youtube";
import { Container, Row, Col } from "reactstrap";

const videoId = "Ph6_relljNY";

const chapters = [
  { time: "0:00", label: "Intro", seconds: 0 },
  { time: "0:44", label: "Unit-level availability", seconds: 44 },
  { time: "1:55", label: "Run a search", seconds: 115 },
  { time: "2:22", label: "Text search field - type anything", seconds: 142 },
  { time: "2:50", label: "Selecting and sending properties", seconds: 170 },
  { time: "3:30", label: "Sending a report (List) to a new client", seconds: 210 },
  { time: "3:48", label: "Sending property report without a phone and email", seconds: 228 },
  { time: "4:30", label: "What happens after you click 'Send'", seconds: 270 },
  { time: "5:28", label: "Clients tab - Adjusting a list", seconds: 328 },
  { time: "6:05", label: "How the URL to a report works", seconds: 365 },
  { time: "6:26", label: "When we update pricing, it reflects in client report", seconds: 386 },
  { time: "7:00", label: "Where and how to manage a client's list", seconds: 420 },
  { time: "7:48", label: "If client isn't receiving the URL", seconds: 468 },
  { time: "8:00", label: "Hiding property names", seconds: 480 },
  { time: "8:30", label: "Clients tab - full overview", seconds: 510 },
  { time: "8:40", label: "Clients tab - starting here vs Properties Tab", seconds: 520 },
  { time: "11:32", label: "Generate leads", seconds: 692 },
  { time: "15:43", label: "Show more rows", seconds: 943 },
  { time: "16:34", label: "Text search field Part 2", seconds: 994 },
  { time: "18:42", label: "Searching amenities", seconds: 1122 },
  { time: "21:50", label: "Searching multiple cities", seconds: 1310 },
  { time: "25:38", label: "Sending a guest card with tour time", seconds: 1538 },
  { time: "28:18", label: "Registering a client without scheduling a tour", seconds: 1698 },
  { time: "29:10", label: "Sending invoices", seconds: 1750 }
];

export default function YoutubeVideoWithChapters() {
  const playerRef = useRef(null);

  const onReady = (event) => {
    playerRef.current = event.target;
  };

  const jumpTo = (e, seconds) => {
    // Only intercept left-click (normal click)
    if (e.button === 0 && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      playerRef.current?.seekTo(seconds, true);
      playerRef.current?.playVideo();
    }
  };

  return (
    <Container>
      <Row className="gy-4 gy-md-0">
        <Col md={8} className="order-2 order-md-1">
          <YouTube
            videoId={videoId}
            onReady={onReady}
            opts={{
              width: "100%",
              height: "450",
              playerVars: {
                rel: 0,
                modestbranding: 1
              }
            }}
          />
        </Col>
        <Col md={4} className="order-1 order-md-2">
          <div style={{ maxHeight: "450px", overflowY: "auto", padding: "1rem" }}>
            <h6 style={{ fontWeight: 'bold', marginBottom: '1rem' }}>Chapters</h6>
            <ul style={{ lineHeight: "1.8", listStyleType: "none", paddingLeft: "0" }}>
              {chapters.map((c) => (
                <li key={c.seconds} style={{ marginBottom: "1rem" }}>
                  <a
                    href={`https://youtu.be/${videoId}?t=${c.seconds}`}
                    onClick={(e) => jumpTo(e, c.seconds)}
                    style={{
                      color: "#065fd4",
                      fontWeight: 500,
                      textDecoration: "none",
                      cursor: "pointer",
                      display: "block"
                    }}
                  >
                    <span style={{ marginRight: "8px" }}>{c.time}</span>
                    <span style={{ color: "#000" }}>{c.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </Col>
      </Row>
    </Container>
  );
}